module.exports = __webpack_public_path__ + "img/evolution4.9eb6dc03.png";